/* eslint-disable no-extend-native */
/* eslint-disable no-param-reassign */
import 'es6-promise/auto'
// import 'babel-polyfill'
import Vue from 'vue'
import vueSmoothScroll from 'vue-smooth-scroll'
import _ from 'lodash'
import VueCharts from 'vue-charts'
import VueLazyLoad from 'vue-lazyload'
import { getIp, getGuidIssue } from '@/common/utils/request'
import { getGUID, isPrerenderer, setGUID, setIp, setLibFile } from '@/common/utils/common'
import axios from 'axios'
import axiosCancel from 'axios-cancel'
import infiniteScroll from 'vue-infinite-scroll'
import constant from '@/common/resources/constant'
import VueMeta from 'vue-meta'
// INFO: IE10 location.origin polyfill
if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
}

const Plugin = {
  install () {
    // TODO: redirection 처리
    // if (/iphone|ipad|android/.test(navigator.userAgent.toLowerCase())) {
    //   if (option !== undefined && option === 'no-redirect') return
    //   window.location.href = `http://m.pooq.co.kr${window.location.pathname}${window.location.search}`
    //   return
    // }
    axiosCancel(axios, { debug: true })
    Vue.prototype.$events = new Vue()
    Vue.prototype.$liveGnbEvents = new Vue()
    Vue.prototype.$previewEvents = new Vue()
    Vue.use(VueCharts)
    Vue.use(VueMeta, { keyName: 'metaInfo',
      attribute: 'data-vue-meta',
      ssrAttribute: 'data-vue-meta-server-rendered',
      tagIDKeyName: 'vmid',
      refreshOnceOnNavigation: true })
    Vue.use(VueLazyLoad, {
      lazyComponent: true,
      preLoad: 1,
      attempt: 3,
      throttleWait: 200 }
    )
    Vue.use(vueSmoothScroll)
    Vue.use(infiniteScroll)
    getIp().then(({ data }) => { setIp(_.get(data, 'ip', '')) })

    if (getGUID() === '') {
      getGuidIssue().then(({ data }) => { setGUID(data) })
    }

    this.addPolyfill()

    if (isPrerenderer()) return

    // [sean:CTD-693] 광고 스크립트 추가
    let dc = document.getElementsByTagName('script')[0]
    if (!dc) { console.warn('no script tag'); return }
    this.addGoogleAnalytics(dc)
    this.addNaverLog(dc)
    this.addFaceBookLog(dc)
    this.addAdBrixSDK(dc)
    // this.addAceCounter();
  },
  // checkBrowser () {
  //   window.browser = new UAParser().getBrowser()
  //   var agt = navigator.userAgent.toLowerCase()
  //   if (agt.indexOf('opera') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('staroffice') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('webtv') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('beonex') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('chimera') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('netpositive') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('phoenix') !== -1) window.location.href = '/browser_update.html'
  //   // if (agt.indexOf("firefox") != -1) return 'Firefox';
  //   // if (agt.indexOf("safari") != -1) return 'Safari';
  //   if (agt.indexOf('skipstone') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('netscape') !== -1) window.location.href = '/browser_update.html'
  //   // if (agt.indexOf('mozilla/5.0') !== -1) window.location.href = '/browser_update.html';
  //   if (agt.indexOf('msie') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
  //     let rv = 0
  //     let ua = navigator.userAgent
  //     let re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})')
  //     if (re.exec(ua) != null) rv = parseFloat(RegExp.$1)
  //     if (rv !== 0 && rv <= 9) {
  //       window.location.href = '/browser_update.html'
  //     }
  //   }
  // },
  addPolyfill () {
    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function (searchString, position) {
        position = position || 0
        return this.substr(position, searchString.length) === searchString
      }
    }
  },
  addPooqPlayerLib (dc) {
    let asl = document.createElement('script')
    asl.async = false
    asl.src = constant.URL_PROTOCOL_WITH_DOMAIN + '/pooqplayer/lib/lib.js'
    dc.parentNode.insertBefore(asl, dc)
  },
  addPooqPlayerAdaptor (dc) {
    let asl = document.createElement('script')
    asl.async = false
    asl.src = constant.URL_PROTOCOL_WITH_DOMAIN + '/pooqplayer/playeradapt.js'
    dc.parentNode.insertBefore(asl, dc)
  },
  addGoogleAnalytics (dc) {
    let asl = document.createElement('script')
    asl.async = true
    asl.src = 'https://www.googletagmanager.com/gtag/js?id=UA-119955855-1'
    dc.parentNode.insertBefore(asl, dc)

    let asc = document.createElement('script')
    asc.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-119955855-1');`
    dc.parentNode.insertBefore(asc, dc)

    // AdWords: 923131705
    let awl = document.createElement('script')
    awl.async = true
    awl.src = 'https://www.googletagmanager.com/gtag/js?id=AW-923131705'
    dc.parentNode.insertBefore(awl, dc)

    let awc = document.createElement('script')
    awc.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-923131705');`
    dc.parentNode.insertBefore(awc, dc)
  },
  addNaverLog (dc) {
    let nsl = document.createElement('script')
    nsl.src = '//wcs.naver.net/wcslog.js'
    dc.parentNode.insertBefore(nsl, dc)

    let nsc = document.createElement('script')
    dc.parentNode.insertBefore(nsc, dc)
    nsl.onload = () => {
      nsc.text = `if (!wcs_add) var wcs_add={};
      wcs_add["wa"] = "s_26546d6bb182";
      if (!_nasa) var _nasa={};
      wcs.inflow("wavve.com");
      wcs_do(_nasa);`
    }
  },
  addFaceBookLog (dc) {
    let fsc = document.createElement('script')
    fsc.text = `!function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '160912788027100');
      fbq('track', 'PageView');`
    dc.parentNode.insertBefore(fsc, dc)

    let fnc = document.createElement('noscript')
    let img = document.createElement('img')
    img.height = 1; img.width = 1; img.style.display = 'none'
    img.src = 'https://www.facebook.com/tr?id=160912788027100&ev=PageView&noscript=1'
    fnc.appendChild(img)
    dc.parentNode.insertBefore(fnc, dc)

    let fpc = document.createElement('script')
    fpc.charset = 'UTF-8'
    fpc.src = '//t1.daumcdn.net/adfit/static/kp.js'
    dc.parentNode.insertBefore(fpc, dc)

    let fpv = document.createElement('script')
    dc.parentNode.insertBefore(fpv, dc)
    fpc.onload = () => {
      fpv.text = 'kakaoPixel(\'5419070585473843165\').pageView();'
    }
  },
  shareFacebook () {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1818575348440201',
        autoLogAppEvents: true,
        version: 'v4.0'
      })
    }
    setLibFile(document, 'script', 'facebook-jssdk', '//connect.facebook.net/ko_KR/sdk.js')
  },
  addAdBrixSDK () {
    const fsc = document.createElement('script')
    fsc.text = '!function(e,r){if(void 0!==e&&!e.adbrix){var t={queue:[]},o=navigator.userAgent.toLowerCase(),n=r.createElement("script"),i="Netscape"===navigator.appName&&-1!==navigator.userAgent.search("Trident")||-1!==o.indexOf("msie")?"abx-web-sdk.ie.min.js":"abx-web-sdk.min.js";n.type="text/javascript",n.async=!0,n.src="//static.adbrix.io/web-sdk/latest/"+i,n.onload=function(){e.adbrix.runQueuedFunctions?e.adbrix.runQueuedFunctions():console.log("[adbrix] Error: could not load SDK")};var a=r.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);["init","onInitialized","login","getUserId","logout","userProperty.get","userProperty.getAll","userProperty.addOrUpdate","userProperty.remove","userProperty.removes","common.signUp","common.invite","common.useCredit","common.purchase","event.send","debug.traceListener","commerceAttr.categories","commerceAttr.product"].forEach(function(e){var r=e.split("."),o=r.pop();r.reduce(function(e,r){return e[r]=e[r]||{}},t)[o]=function(){t.queue.push([e,arguments])}}),e.adbrix=t}}(window,document);'
    document.body.appendChild(fsc)
    const fsv = document.createElement('script')
    const adbrixConfig = {
      appkey: 'DjUBU1MFhk6d6A9Fyn76LQ',
      webSecretkey: 'ZpdJvlS5o0WGy2dVvFbNZA',
      traceLevel: 0,
      isExecPageViewEvent: false
    }
    fsv.text = `window.adbrix.init(${JSON.stringify(adbrixConfig)});`
    document.head.appendChild(fsv)
  }
}

export default Plugin
